import { Navigate, useParams } from "react-router";
import t from "@/lang/lang";
import { useOmniContractShowQuery } from "@/services/backend/omni/contract/api/contract-api";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Alert, AlertTitle } from "@/shared/components/ui/alert";

/**
 * ContractRedirectRoute resolves the path of a contract of an omni process
 * known only by its id, e.g. from the last updated document of the process
 * list: a contract page lives below the offer it was made from.
 */
export function ContractRedirectRoute() {
  const { contractId } = useParams();
  const { data: contract, error } = useOmniContractShowQuery({
    id: contractId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }
  if (!contract) {
    return <CardSkeleton />;
  }
  if (!contract.offerId) {
    return (
      <Alert variant="destructive">
        <AlertTitle>{t("Der Vertrag gehört zu keinem Angebot.")}</AlertTitle>
      </Alert>
    );
  }

  return (
    <Navigate
      to={`../offers/${contract.offerId}/contracts/${contract.id}`}
      replace
    />
  );
}
